import axios from "axios";
import Constants from "./Constants";


export const  ApiGet = (endpoint) => {

   
    return new Promise((resolve , reject) => {

    axios({
        method: "get",
        url: Constants.url + endpoint,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
    });
  }


export const  ApiPost = (endpoint , data) => {

   
    return new Promise((resolve , reject) => {

    axios({
        method: "post",
        url: Constants.url + endpoint,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: data
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
    });
  }


export const  ApiDelete = (endpoint) => {

   
    return new Promise((resolve , reject) => {

    axios({
        method: "DELETE",
        url: Constants.url + endpoint,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        // data: data
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
    });
  }